import {
  StartSettingAdapterInteface,
  ListStartSettingsInput,
} from 'src/adapter/StartSettingAdapterInterface';
import {
  StartSettingSendAttributes,
  StartSettingGetAttributes,
} from 'src/models/StartSettingModel';
import { api } from 'boot/axios';
import { axiosErrorHandler } from 'src/error/handler/axiosErrorHandler';
export class AxiosStartSettingAdapter implements StartSettingAdapterInteface {
  async listStartSettings(
    conditions?: ListStartSettingsInput
  ): Promise<{ total: number; data: StartSettingGetAttributes[] }> {
    try {
      const res = await api.get('/start-settings', {
        params: conditions,
      });
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async getStartSetting(id: string): Promise<StartSettingGetAttributes> {
    try {
      const res = await api.get(`/start-settings/${id}`);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
  async updateStartSetting(
    id: string,
    attributes: StartSettingSendAttributes
  ): Promise<StartSettingGetAttributes> {
    try {
      const res = await api.put(`/start-settings/${id}`, attributes);
      return res.data;
    } catch (e: any) {
      throw axiosErrorHandler(e);
    }
  }
}
